export default __webpack_public_path__ + "static/baseball-5fe8626492f514f94cb2d8ba6b38478b.gif";